import moment from 'moment';
import getCurrentTimezoneOffset from './getCurrentTimezoneOffset';

export default function formatTimeToUK(time){
    return moment(time, ['hh:mm:ss']).add(getCurrentTimezoneOffset(), "minute").format("hh:mm A")
}